const SERIAL_NUMBER_REGEX = /^HQ[0-9A-Za-z]{9}$/;
const VRM_ID_REGEX = /^[a-zA-Z0-9]{12}$/;

export { SERIAL_NUMBER_REGEX, VRM_ID_REGEX };
